import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { MenuIcon } from "../../../Components";

const SearchHeaderItem = ({
  item,
  onClick,
  className,
  automationId,
  trackingInfo
}) => {
  const { iconKey, iconURL, URL, target } = item;

  const classes = classNames(className);

  return (
    <a
      className={classes}
      onClick={onClick}
      href={URL}
      data-testid={automationId}
      target={target}
      data-category={trackingInfo.dataCategory}
      data-action={trackingInfo.dataAction}
      data-label={trackingInfo.dataLabel}
      data-value=""
    >
      <MenuIcon iconKey={iconKey} iconURL={iconURL}></MenuIcon>
    </a>
  );
};

SearchHeaderItem.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  automationId: PropTypes.string,
  trackingInfo: PropTypes.object
};

export default React.memo(SearchHeaderItem);
